import { useRef } from "react";

export const FileUploader = ({ handleFile }) => {
  const hiddenFileInput = useRef(null);

  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    handleFile(fileUploaded);

    // ✅ Reset input to allow same file to be selected again
    event.target.value = null;
  };

  return (
    <>
      <button className="custom-btn btn-sm" onClick={handleClick}>
        <i className="bi bi-upload"></i>&nbsp;
        <span>Asset Import&nbsp;</span>
        <span className="text-danger">*</span>
      </button>
      <input
        type="file"
        accept=".xls,.xlsx"
        onChange={handleChange}
        ref={hiddenFileInput}
        style={{ display: "none" }}
      />
    </>
  );
};

export default FileUploader;
